import { type FC } from "react";

import { type MachineGroup } from "@/schemas/machine-group";

import { MachineGroupStatusDisplay } from "../machine-group-status";
import { MachineGroupProductionEnableControl } from "../machine-group-production-enable-control";

interface MachineGroupStatusProps {
	readonly selectedValue: MachineGroup;
}

export const MachineGroupStatus: FC<MachineGroupStatusProps> = ({ selectedValue: currentMachineGroup }) => {
	const machineOnline = currentMachineGroup?.status.toLowerCase() === "online";
	const machineGroupInPlay = currentMachineGroup?.productionEnabled;
	const playButtonEnabled = machineGroupInPlay || machineOnline;

	return (
		<>
			<MachineGroupStatusDisplay machineGroupStatus={currentMachineGroup.status} />
			<MachineGroupProductionEnableControl
				machineGroupId={currentMachineGroup.id}
				disabled={!playButtonEnabled}
				productionEnabled={currentMachineGroup.productionEnabled}
			/>
		</>
	);
};
